import React, { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { spacing } from '../../../theme/index';
export const Form = forwardRef(({ direction = 'horizontal', formStyle, children, className, ...rest }, ref) => {
    return (<StyledForm direction={direction} className={className} ref={ref} style={formStyle} {...rest}>
      {children}
    </StyledForm>);
});
export default Form;
const StyledForm = styled.form `
  display: flex;
  flex-wrap: wrap;

  ${({ direction }) => direction === 'horizontal' &&
    css `
      flex-direction: row;
      > div:not(:last-child) {
        margin-right: ${spacing.space24};
      }
      > span:last-child {
        margin-top: ${spacing.space12};
      }
    `};

  ${({ direction }) => direction === 'vertical' &&
    css `
      flex-direction: column;
      > div:not(:first-child) {
        margin-top: ${spacing.space12};
      }
      > span:last-child {
        margin-top: ${spacing.space12};
      }
    `};
`;
